module.exports = __webpack_public_path__ + "img/moeg.82ecf6ff.jpg";